import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Resets scroll to top of window on every route change.
 * Mount once inside <BrowserRouter>.
 */
export default function ScrollToTop() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // If the URL includes an anchor (#hash), let the browser jump to that element
    if (window.location.hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, search]);
  return null;
}
